import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';

import { HeaderAction } from '@app/components/ListHeaderActions';

interface AddNewButtonProps {
  action: HeaderAction;
}

export const AddNewButton = ({ action }: AddNewButtonProps) => {
  return (
    <Button
      data-cy="addNew"
      variant="contained"
      color="primary"
      sx={{ marginLeft: 2, paddingTop: '5px', paddingBottom: '5px' }}
      startIcon={<AddIcon />}
      onClick={action.handler}>
      {action.label ?? 'ADD NEW'}
    </Button>
  );
};
